__turbopack_context__.v({
  "divider": "side-nav-divider-module-scss-module__ITL1SG__divider",
});
